<template>
  <v-flex>
    <v-card class="elevation-10 mr-4 mt-4 fixed-viewer-wrapper">
      <v-card-title class="pb-1">
        <v-flex xs12 class="pb-0 pr-4">
      <h3 class="pr-2 text-truncate">{{ documentFieldNameTitlized }}</h3>
      </v-flex>
       <v-flex pt-0 pb-2>
                <v-btn icon
                   class="ma-0 close-panel mb-2"
                  @click.stop="hideSidePanel()">
                  <v-icon color="error">cancel</v-icon>
                </v-btn>
        </v-flex> 
        </v-card-title
      >
      <v-card-text class="pa-0">

        <h4 class="px-3 pb-3 text-truncate">
          Filename <b>{{ fileAttachment.filename }}</b>
        </h4>
        <object
          v-if="fileAttachment"
          :data="documentURL"
          type="application/pdf"
          class="viewer"
          width="100%"
          height="300px"
        >
          <embed
            v-if="fileAttachment"
            :src="documentURL"
            type="application/pdf"
            width="100%"
            height="100%"
          />
        </object>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import Helpers from "@/helpers.js";
import { mapState } from "vuex";

export default {
  name: "CaseDocumentSidePanel",
  components: {},
  data: () => ({}),
  props: {
    documentFieldName: {
      type: String,
      required: true
    },
    fileAttachment: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapState({
      userPreferences: (state) => state.currentUser.me.preferences,
      currentUser: (state) => state.currentUser,
    }),
    receivedAt() {
      return Helpers.formatTimeAsGmail(
        new Date(this.fileAttachment.updatedAt),
        this.userPreferences.dateFormat
      );
    },
    documentFieldNameTitlized() {
      return Helpers.titleize(this.documentFieldName)
    },
    documentURL() {
      const token = window.localStorage.getItem('session')
      const path = this.fileAttachment.url
      const baseURL = window.location.href.startsWith("http://localhost") ? `http://localhost:6543${path}` : path
      return `${baseURL}?token=${token}`
    }
  },
  methods: {
    hideSidePanel() {
      this.$store.dispatch("hideDocumentSidePanel");
    },
  },
};
</script>

<style>

.viewer {
  height:calc(100vh - 230px);
  margin-bottom: -5px !important;
}

.with-summary .viewer {
  height:calc(100vh - 290px);
}

.fixed-viewer-wrapper {
  position: fixed !important;
    right: 0;
  width: calc(50% - 42px);
}
</style>